import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
    NbAlertModule,
    NbIconModule,
    NbSelectModule,
    NbRadioModule,
    NbInputModule,
    NbToggleModule,
    NbCardModule,
    NbCheckboxComponent,
    NbCheckboxModule,
    NbButtonModule,
    NbTooltipModule,
} from '@nebular/theme';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { RecaptchaModule } from 'ng-recaptcha';

import { IconsComponent } from './icons/icons.component';
import { HorizontalScrollComponent } from './horizontal-scroll/horizontal-scroll.component';
import { RadioComponent } from './radio/radio.component';
import { BreadcrumbsMenuComponent } from './breadcrumbs-menu/breadcrumbs-menu.component';
import { DescriptionLogoComponent } from './description-logo/description-logo.component';
import { PaginationComponent } from './pagination/pagination.component';
import { MessagesComponent } from './messages/messages.component';
import { RoadmapComponent } from './roadmap/roadmap.component';
import { InputComponent } from './input/input.component';
import { PropertiesFormComponent } from './properties-form/properties-form.component';
import { DynamicInputComponent } from './properties-form/shared/dynamic-input/dynamic-input.component';
import { PropertiesFormService } from './properties-form/properties-form.service';
import { DynamicInputService } from './properties-form/shared/dynamic-input/dynamic-input.service';
import { DropdownSearchComponent } from './dropdown-search/dropdown-search.component';
import { PropertiesFormValidationMessageComponent } from './properties-form/shared/properties-form-validation-message/properties-form-validation-message.component';
import { PropertiesFormNotificationMessageComponent } from './properties-form/shared/properties-form-notification-message/properties-form-notification-message.component';
import { UiComponentsService } from './ui-components.service';
import { InputDateComponent } from './input-date/input-date.component';
import { InputActionsComponent } from './input-actions/input-actions.component';
import { ArrayNumberSortPipe } from '@shared/pipes/array-number-sorting.pipe';
import { CaptchaComponent } from './captcha/captcha.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    NbAlertModule,
    NbIconModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NbInputModule,
    NbSelectModule,
    NbRadioModule,
    NbCardModule,
    NbToggleModule,
    NbTooltipModule,
    NbCheckboxModule,
    NbButtonModule,
    RecaptchaModule
  ],
  declarations: [
    HorizontalScrollComponent,
    IconsComponent,
    RadioComponent,
    BreadcrumbsMenuComponent,
    DescriptionLogoComponent,
    PaginationComponent,
    MessagesComponent,
    RoadmapComponent,
    InputComponent,
    InputDateComponent,
    PropertiesFormComponent,
    DynamicInputComponent,
    PropertiesFormValidationMessageComponent,
    PropertiesFormNotificationMessageComponent,
    DropdownSearchComponent,
    InputActionsComponent,
    DropdownSearchComponent,
    CaptchaComponent,
    ArrayNumberSortPipe
  ],
  exports: [
    HorizontalScrollComponent,
    IconsComponent,
    RadioComponent,
    BreadcrumbsMenuComponent,
    DescriptionLogoComponent,
    PaginationComponent,
    MessagesComponent,
    RoadmapComponent,
    InputComponent,
    InputDateComponent,
    PropertiesFormComponent,
    DynamicInputComponent,
    PropertiesFormValidationMessageComponent,
    PropertiesFormNotificationMessageComponent,
    DropdownSearchComponent,
    NbCheckboxComponent,
    InputActionsComponent,
    ArrayNumberSortPipe,
    CaptchaComponent
  ]
})
export class UiComponentsModule {
  static forRoot(): ModuleWithProviders<UiComponentsModule> {
    return {
      ngModule: UiComponentsModule,
      providers: [
        PropertiesFormService,
        DynamicInputService,
        UiComponentsService
      ]
    };
  }
}
